import { Box, BoxProps, Text } from "@chakra-ui/react";

export interface StatCardProps extends BoxProps {
  title: string;
  value: string;
  children: string;
  colorScheme?: string;
}
export const StatCard = (props: StatCardProps) => {
  const { title, value, children, colorScheme, ...rest } = props;
  return (
    <Box
      as="dl"
      bg={"white"}
      p="6"
      rounded="lg"
      shadow="md"
      _hover={{
        transform: "scale(1.05)",
      }}
      cursor="pointer"
      transition="transform 0.2s"
      {...rest}
    >
      <Text as="dt" color={`${colorScheme || "blue"}.500`} fontWeight="bold">
        {title}
      </Text>
      <Text
        as="dd"
        fontSize={value.length > 5 ? "4xl" : "5xl"}
        fontFamily="numerical"
        fontWeight="bold"
        lineHeight="1"
        my="4"
      >
        {value}
      </Text>
      <Text as="dd" color={"blueGray.600"} fontSize="sm">
        {children}
      </Text>
    </Box>
  );
};
